// extracted by mini-css-extract-plugin
module.exports = {"switch":"styles_switch__US8wW","switch--noLabel":"styles_switch--noLabel__MLKZ2","fadeInOut":"styles_fadeInOut__xI8cW","loader":"styles_loader__xNJ_2"};